import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const NumberInputClassName = `${CLASS_NAME_PREFIX}-number-input`;
